// extracted by mini-css-extract-plugin
module.exports = {"animated-number":"animated-number--SSiyq","animatedNumber":"animated-number--SSiyq"};